import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import BlogPost from "./pages/BlogPost";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import ListingPricing from "./pages/ListingPricing";
import CookieConsent from "./components/CookieConsent";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/subscribers" element={<Admin />} />
            <Route path="/listing-pricing" element={<ListingPricing />} />
            {/* Redirect old blog slug to new one */}
            <Route path="/blog/dubai-str-market-2025" element={<Navigate to="/blog/dubai-str-market-2026" replace />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </BrowserRouter>
        <CookieConsent />
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
